exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.imageContainer[data-v-10c79870]{display:flex;justify-content:center;width:100%\n}\n.imageContainer img[data-v-10c79870]{width:300px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-10c79870","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/mediaItem/ThumbnailUploader.vue
// module id = 202
// module chunks = 0